import { z } from 'zod'
import { PaymentType } from '../../enums/payment-type.enum'
import { importAliasSchema } from './create-account.schema'

export const updateAccountSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters').max(100).optional(),
  importAlias: importAliasSchema,
  paymentType: z.nativeEnum(PaymentType).optional(),
  default: z.boolean().optional(),
  archived: z.boolean().optional(),
  creditLimit: z.number().positive('Credit limit must be greater than 0').optional(),
  closingDay: z.number().int().min(1).max(31).optional(),
  includeInTotal: z.boolean().optional(),
})

export type UpdateAccountDto = z.infer<typeof updateAccountSchema>
